module.exports = __webpack_public_path__ + "img/lbc-small-black-nolabel.6b5057c6.svg";